import React, { Component } from 'react';
import { Menu } from 'antd';

const { SubMenu } = Menu;

class SideNav extends Component {
    constructor(props) {
        super(props);
        this.state = {
            current: this.props.selectKey,
        };
    }

    handleClick = e => {
        this.setState({ current: e.key });
    }

    render() {
        const { curRole, invState } = sessionStorage;
        const isPM = curRole == 'PM';
        const isBO = curRole == 'BO';
        const isBD = curRole == 'BD';
        const isTAL = curRole == 'TAL';
        const isBDO = curRole == 'BDO';
        const isPA = curRole == 'PA';
        const isCTA = curRole == 'CTA';
        const isVP = curRole == 'VP';
        const isFIN = curRole == 'FIN';
        const isBA = curRole == 'BA';
        const isBAL = curRole == 'BAL';
        const isPML = curRole == 'PML';
        const isCSA = curRole == 'CSA';
        const isCSAL = curRole == 'CSAL';
        const isCRCC = curRole == 'CRCC';
        const isCRCM = curRole == 'CRCM';
        return (
            <aside className="sidebar">
                <Menu
                    onClick={this.handleClick}
                    defaultOpenKeys={['sub1']}
                    selectedKeys={[this.state.current]}
                    mode="inline"
                >
                {
                    invState == 3 &&
                    <SubMenu key="sub1" title={<span><i className="icon iconfont">&#xe64e;</i><span>项目合同</span></span>}>
                        <Menu.Item key="mainContract">
                            <a href="#/projectContract/mainContract">主合同记录</a>
                        </Menu.Item>
                        <Menu.Item key="childContract">
                            <a href="#/projectContract/childContract">子合同记录</a>
                        </Menu.Item>
                    </SubMenu>
                }
                {
                    invState == 1 &&
                    <SubMenu key="sub1" title={<span><i className="icon iconfont">&#xe64e;</i><span>项目合同</span></span>}>
                        <Menu.Item key="contractRecord">
                            <a href="#/projectContract/contractRecord">合同记录</a>
                        </Menu.Item>
                        <Menu.Item key="requestRecord">
                            <a href="#/projectContract/requestRecord">合同请款记录</a>
                        </Menu.Item>
                        {
                            (isPM || isBD || isBA || isTAL || isBAL || isPML || isCSA || isCSAL) &&
                            <Menu.Item key="returnedMoney">
                                <a href="#/projectContract/returnedMoney">发票和回款记录</a>
                            </Menu.Item>
                        }
                        {
                            (isPM || isBO || isCRCC || isCRCM  || isTAL || isPML) &&
                            <Menu.Item key="applyJdeCode">
                                <a href="#/projectContract/applyJdeCode">JDE建号申请记录</a>
                            </Menu.Item>
                        }
                        {
                            (isPM) &&
                            <Menu.Item key="contractInfoChange">
                                <a href="#/projectContract/contractInfoChange">合同信息变更申请</a>
                            </Menu.Item>
                        }
                        {
                            (isPM || isBO || isCRCC || isCRCM  || isTAL || isPML) &&
                            <Menu.Item key="alterJdeCode">
                                <a href="#/projectContract/alterJdeCode">JDE主项目号变更申请</a>
                            </Menu.Item>
                        }
                        <Menu.Item key="terminationApply">
                            <a href="#/projectContract/terminationApply">项目终止申请</a>
                        </Menu.Item>
                        <Menu.Item key="costOfContractSplit">
                            <a href="#/projectContract/costOfContractSplit">合同费用拆分</a>
                        </Menu.Item>
                        {/* <Menu.Item key="endAgreement">
                            <a href="#/projectContract/endAgreement">终止协议</a>
                        </Menu.Item> */}
                    </SubMenu>
                }
                </Menu>
            </aside>
        );
    }
}

export default SideNav;


// WEBPACK FOOTER //
// ./src/components/projectContract/SideNav.js